<template>
  <div id="app">
    <component :is="layout" :class="layout">
      <router-view></router-view>
    </component>
  </div>
</template>
<script>
import {mapGetters} from "vuex";

export default {
  computed: {
    ...mapGetters("oidcStore", ["oidcUser"]),
    getMobile() {
      var flag = navigator.userAgent.match(
          /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
      if (flag === null) {
        return false;
      } else {
        return true;
      }
    },
    layout() {
      let meta = this.getMobile;
      let layout = meta ? 'mobile' : 'pc';
      return layout;
    }
  },
  mounted() {
    
  }
}
</script>
<style>
html{
  --textLight: #439DFF;
  --circleColor: #3771D9;
  --bgColor1: #336DD5;
  --bgColor2: #5F97FA;
}
</style>



// WEBPACK FOOTER //
// src/App.vue